import { t } from '../../../../../../common/i18n.js'
import type { Language } from '../../../../../../common/types/i18n.js'
import type {
    TenureCohort,
    TenurePayload,
} from '../../../../../../server/controllers/portal/dashboard-card-payloads.js'
import './tenure-card.css'

const formatCohort = (cohort: TenureCohort, lang: Language): string =>
    cohort.count > 0
        ? t.portal.dashboard.cards.tenure.value(cohort.years, cohort.months)(lang)
        : t.portal.dashboard.cards.tenure.empty(lang)

export const TenureCard = ({ data, lang }: { data: TenurePayload; lang: Language }) => {
    const chips = [
        { key: 'nope', label: t.portal.dashboard.cards.tenure.nope(lang), cohort: data.nope },
        { key: 'play', label: t.portal.dashboard.cards.tenure.play(lang), cohort: data.play },
        { key: 'both', label: t.portal.dashboard.cards.tenure.both(lang), cohort: data.both },
    ]

    return (
        <>
            <span className="portal-card__value">{formatCohort(data.total, lang)}</span>
            <span className="portal-card__subtext">
                {t.portal.dashboard.cards.tenure.total(lang)}
            </span>
            <div className="portal-tenure-card__group">
                <span className="portal-tenure-card__group-label">
                    {t.portal.dashboard.cards.tenure.byCompany(lang)}
                </span>
                <div className="portal-tenure-card__chips">
                    {chips.map((chip) => (
                        <span key={chip.key} className="portal-tenure-card__chip">
                            <span className="portal-tenure-card__chip-name">{chip.label}</span>{' '}
                            <span className="portal-tenure-card__chip-count">
                                {formatCohort(chip.cohort, lang)}
                            </span>
                        </span>
                    ))}
                </div>
            </div>
            {data.byTeam.length > 0 && (
                <div className="portal-tenure-card__group portal-tenure-card__group--team">
                    <span className="portal-tenure-card__group-label">
                        {t.portal.dashboard.cards.tenure.byTeam(lang)}
                    </span>
                    <div className="portal-tenure-card__chips">
                        {data.byTeam.map((row) => (
                            <span
                                key={row.teamId}
                                className="portal-tenure-card__chip portal-tenure-card__chip--team"
                            >
                                <span className="portal-tenure-card__chip-name">
                                    {row.teamName}
                                </span>{' '}
                                <span className="portal-tenure-card__chip-count">
                                    {row.count > 0
                                        ? t.portal.dashboard.cards.tenure.value(
                                              row.years,
                                              row.months,
                                          )(lang)
                                        : t.portal.dashboard.cards.tenure.empty(lang)}
                                </span>
                            </span>
                        ))}
                    </div>
                </div>
            )}
        </>
    )
}
